module.exports = __webpack_public_path__ + "img/back.2f4999e9.svg";